import { render } from "./DemandDates.component.vue?vue&type=template&id=510536a4&scoped=true"
import script from "./DemandDates.component.vue?vue&type=script&lang=js"
export * from "./DemandDates.component.vue?vue&type=script&lang=js"

import "./DemandDates.component.vue?vue&type=style&index=0&id=510536a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510536a4"]])

export default __exports__